import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { getPortalDesignBootstrap } from '../../lib/portalDesignBootstrap';

export const DashboardLayout = ({ children, title }) => {
  const headline = typeof title === 'string' && title.trim() !== '' ? title : '';
  const portalDesign = getPortalDesignBootstrap();

  return (
    <div
      className="min-h-screen bg-background"
      data-testid="dashboard-layout"
      style={{ backgroundColor: portalDesign.contentBackgroundColor }}
    >
      <Sidebar />
      <div className="pl-64">
        <Header />
        <main className="p-6" style={{ backgroundColor: portalDesign.contentBackgroundColor }}>
          {headline !== '' && (
            <div className="mb-6" data-testid="page-headline">
              <h1 className="font-heading text-2xl font-bold text-foreground tracking-tight">{headline}</h1>
            </div>
          )}
          {children}
        </main>
      </div>
    </div>
  );
};
